export default __webpack_public_path__ + "static/media/misc-pantry1-1920w.9496a0e3.webp";